import { render, staticRenderFns } from "./teamResult.vue?vue&type=template&id=2b8bebac&scoped=true"
import script from "./teamResult.vue?vue&type=script&lang=js"
export * from "./teamResult.vue?vue&type=script&lang=js"
import style0 from "./teamResult.vue?vue&type=style&index=0&id=2b8bebac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8bebac",
  null
  
)

export default component.exports